module.exports = __webpack_public_path__ + "static/topography-7e9d9777a098bfed4bf871e7a54b033d.svg";